import { Dropdown, DropdownButton, DropdownItem, DropdownLabel, DropdownMenu, MenubarItem } from '@criteria-labs/react'
import { InformationCircleIcon } from '@heroicons/react/24/outline'

export function AboutMenu() {
  return (
    <Dropdown>
      <DropdownButton as={MenubarItem}>About</DropdownButton>
      <DropdownMenu anchor="bottom start" modal={false}>
        <DropdownItem href="https://criteria.sh/products/playground" target="_blank">
          <InformationCircleIcon />
          <DropdownLabel>About Criteria Playground</DropdownLabel>
        </DropdownItem>
      </DropdownMenu>
    </Dropdown>
  )
}
